import { TierRateByYear } from './../../interfaces';

export const rates: TierRateByYear = {
    2018: [ { percentage: 14 } ],
    2019: [ { percentage: 14 } ],
    2020: [ { percentage: 14 } ],
    2021: [ { percentage: 14 } ],
    2022: [ { percentage: 14 } ],
    2023: [ { percentage: 14 } ],
    2024: [ { percentage: 13.31 } ]
};
